<template>
	<div v-html="compiledMarkdown"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { marked } from 'marked';

const props = defineProps<{
	raw: string;
}>();

const compiledMarkdown = computed(() => {
	return marked(props.raw);
});
</script>
